export const PrescriptionQR = {
  Label: 'QRコード読み取り',
  Explanation: '処方箋にQRコードがある場合は読み取って下さい。',
  ReSubmit:
    'QRコードの内容と処方箋写真の内容に差があったため、QRを読み取り直して再送信して下さい。',
  ReadOff: 'QRを読み取り',
  ReadOn: 'QRを読み取り済',
  Dialog: {
    Text: '処方箋QRコード読み取り',
    ReadText: '読み込み済みのQRコードです',
    ErrorText: 'QRコードの読み込みに失敗しました',
  },
  Reload: '再読み取り',
};
